import script from "./ThemeDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeDataTable.vue?vue&type=script&setup=true&lang=js"

import "./ThemeDataTable.vue?vue&type=style&index=0&id=4195ea6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4195ea6a"]])

export default __exports__